import { render, staticRenderFns } from "./RightBox.vue?vue&type=template&id=cd200476&"
import script from "./RightBox.vue?vue&type=script&lang=ts&"
export * from "./RightBox.vue?vue&type=script&lang=ts&"
import style0 from "./RightBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports